import { algorand } from "./algorand.js"
import { binance } from "./binance.js"
import { bitcash } from "./bitcash.js"
import { bitcoin } from "./bitcoin.js"
import { bitcoin2 } from "./bitcoin2.js"
import { bitcoinsv } from "./bitcoinsv.js"
import { cardano } from "./cardano.js"
import { conflux } from "./conflux.js"
import { cosmoshub } from "./cosmoshub.js"
import { crypto_mainnet } from "./crypto_mainnet.js"
import { dash } from "./dash.js"
import { zcash2 } from "./zcash2.js"
import { dogecoin } from "./dogecoin.js"
import { elrond } from "./elrond.js"
import { ethereum } from "./ethereum.js"
import { everscale } from "./everscale.js"
import { filecoin } from "./filecoin.js"
import { flow } from "./flow.js"
import { hedera } from "./hedera.js"
import { litecoin } from "./litecoin.js"
import { litecoin2 } from "./litecoin2.js"
import { ripple } from "./ripple.js"
import { solana } from "./solana.js"
import { stellar } from "./stellar.js"
import { tezos } from "./tezos.js"
import { tron } from "./tron.js"
import { zcash } from "./zcash.js"
import { dash2 } from "./dash2.js"

export const networksConfig = {
    algorand,
    binance,
    bitcash,
    bitcoin,
    bitcoin2,
    bitcoinsv,
    cardano,
    conflux,
    cosmoshub,
    crypto_mainnet,
    dash,
    dash2,
    dogecoin,
    elrond,
    ethereum,
    everscale,
    filecoin,
    flow,
    hedera,
    litecoin,
    litecoin2,
    ripple,
    solana,
    stellar,
    tezos,
    tron,
    zcash,
    zcash2,
}

export const blockchains = [
    algorand,
    binance,
    bitcash,
    bitcoin,
    bitcoin2,
    bitcoinsv,
    cardano,
    conflux,
    cosmoshub,
    crypto_mainnet,
    dash,
    dash2,
    dogecoin,
    elrond,
    ethereum,
    everscale,
    filecoin,
    flow,
    hedera,
    litecoin,
    litecoin2,
    ripple,
    solana,
    stellar,
    tezos,
    tron,
    zcash,
    zcash2
].filter((blockchain) => blockchain.check)

export const blockchainsDedup: Array<{name: string; title: string}> = Object.values(
    blockchains.reduce((acc, blockchain) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
        acc[blockchain.name] = blockchain
        return acc
    }, {})
)


